import { Image, ImageResizeMode, ImageProps } from 'react-native';
export const RNFastImage = Image;
export type RNResizeMode = ImageResizeMode;
export interface RNFastImageProps extends ImageProps {}
